// components/CostCell.js
import {Tooltip} from "antd";
import {memo, useMemo} from "react";
import {monthsShort, parseCostString} from "../../utils/costUtils";

export const CostCell = memo(({costString, nds}) => {
    const costs = useMemo(() => parseCostString(costString), [costString]);
    const currentMonth = new Date().getMonth();
    const currentCost = costs[currentMonth] || 0;
    const currentCostWithTax = +nds > 0 ? currentCost * 1.21 : currentCost;


    const tooltipContent = useMemo(() => (
        <div style={{
            minWidth: '220px',
            backgroundColor: '#1f1f1f',
            borderRadius: '6px'
        }}>
            <div style={{
                padding: '10px 14px',
                borderBottom: '1px solid #333',
                fontSize: '13px',
                fontWeight: 600,
                color: '#e0e0e0',
                letterSpacing: '0.3px'
            }}>
                📊 Помесячная стоимость (€)
            </div>

            {costs.map((cost, index) => (
                <div key={index} style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '8px 14px',
                    backgroundColor: index === currentMonth ? '#2a2a2a' : 'transparent',
                    fontSize: '13px',
                    borderBottom: index < costs.length - 1 ? '1px solid #2a2a2a' : 'none',
                    transition: 'background-color 0.2s'
                }}>
                    <span style={{
                        color: index === currentMonth ? '#69c0ff' : '#b0b0b0',
                        fontWeight: index === currentMonth ? 600 : 400
                    }}>
                        {monthsShort[index]}:
                    </span>
                    <span style={{
                        fontFamily: 'monospace',
                        fontWeight: 500,
                        color: cost > 0 ? '#b7eb8f' : '#8c8c8c'
                    }}>
                        €{cost.toFixed(2)} (€{currentCostWithTax.toFixed(2)})
                    </span>
                </div>
            ))}
        </div>
    ), [costs, currentMonth]);

    return (
        <Tooltip
            title={tooltipContent}
            placement="left"
            overlayInnerStyle={{padding: 0, backgroundColor: 'transparent'}}
            color="#1f1f1f"
        >
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                width: 'fit-content',
                fontFamily: 'monospace',
                margin: '0 auto',
                borderRadius: '30px', // Скругленные пилюли
            }}>
                {/* Без НДС */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: '12px',
                    fontSize: '12px',
                    color: '#6b6b6b',
                    borderBottom: '1px dashed #c9c9c9',
                    paddingBottom: '3px',
                    marginBottom: '3px'
                }}>
                    <span>Без НДС</span>
                    <span style={{
                        fontSize: '12px',
                        fontWeight: '600',
                        color: currentCost > 0 ? '#2f5e8c' : '#b5b5b5',
                    }}>
      €{currentCost.toFixed(2)}
    </span>
                </div>

                {/* С НДС */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: '12px',
                    fontSize: '12px',
                    color: '#6b6b6b',
                    borderBottom: '1px dashed #c9c9c9',
                    paddingBottom: '3px',
                    marginBottom: '3px'
                }}>
                    <span>С НДС</span>
                    <span style={{
                        fontSize: '14px',
                        fontWeight: 'bold',
                        color: currentCostWithTax > 0 ? '#1f7b4c' : '#b5b5b5',
                        letterSpacing: '-0.5px'
                    }}>
      €{currentCostWithTax.toFixed(2)}
    </span>
                </div>
            </div>
        </Tooltip>
    );
});

CostCell.displayName = 'CostCell';